import React, { useState, useContext, useEffect } from "react";
// import Header from './HeaderComponent';
// import SidebarComponent from './SidebarComponent';
import BdmDashboardComponent from "./BdmDashboard/BdmDashboardComponent";

import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import NotificationComponent from './Notification/NotificationComponent';
import {
  AccountCircle,
  AccountCircleTwoTone,
  HistoryEdu,
  ListAlt,
} from "@mui/icons-material";
import { LoginContext } from "./LoginPage/LoginContext";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import {
  Alert,
  Avatar,
  Badge,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItemAvatar,
  Snackbar,
  Tab,
  Tabs,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Person2Icon from "@mui/icons-material/Person2";
import Divider from "@mui/material/Divider";
import LogoutIcon from "@mui/icons-material/Logout";
import ib_logo from "../icons/IB_logo.png";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SpeedIcon from "@mui/icons-material/Speed";
import GroupIcon from "@mui/icons-material/Group";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import Tooltip from "@mui/material/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../Actions/LoginAction";
import useMediaQuery from "@mui/material/useMediaQuery";
import leadFormStyles from "./Leads Page/leadFormStyles.module.css";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import {
  ATTENDANCE_OUT,
  CALL_DISCONNECTION,
  GET_LEAD_BY_BDM_API,
  GET_NOTIFICATION,
  ROLES,
  UPDATE_NOTIFICATION,
} from "../constants";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import NotificationsIcon from "@mui/icons-material/Notifications";
import axios from "axios";
import dayjs from "dayjs";
import MessageIcon from "@mui/icons-material/Message";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ListIcon from "@mui/icons-material/List";
import PersonIcon from "@mui/icons-material/Person";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useSocket } from "./SocketContext";
import { emit } from "./eventEmitter";
import CloudIcon from "@mui/icons-material/Cloud";
import SummarizeIcon from "@mui/icons-material/Summarize";
import QrCodeIcon from "@mui/icons-material/QrCode";
import SettingsIcon from "@mui/icons-material/Settings";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CallMadeIcon from "@mui/icons-material/CallMade";
import QueueIcon from "@mui/icons-material/Queue";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ViewListIcon from "@mui/icons-material/ViewList";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import {
  BookCheck,
  Calendar1,
  PhoneCall,
  ChartBar,
  CircleUserRound,
  FileDown,
  ListChecks,
  MapPinned,
  Palmtree,
  Users,
} from "lucide-react";
import RouteIcon from "@mui/icons-material/Route";
import Cookies from "js-cookie";
import moment from "moment";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { Shrimp } from "@phosphor-icons/react";
import BadgeIcon from "@mui/icons-material/Badge";
import CampaignIcon from "@mui/icons-material/Campaign";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  backgroundColor: "#097969",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// Snackbar styles
const snackbarStyles = {
  backgroundColor: "#ff9800", // Bright color (e.g., orange)
  fontWeight: "bold", // Make the text bolder
  color: "white", // Text color
  fontSize: "16px", // Larger font size for visibility
  textAlign: "center", // Center the text
};

const ShrimpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-shrimp-icon ${props.className || ""}`}
    {...props}
  >
    <path d="M11 12h.01" />
    <path d="M13 22c.5-.5 1.12-1 2.5-1-1.38 0-2-.5-2.5-1" />
    <path d="M14 2a3.28 3.28 0 0 1-3.227 1.798l-6.17-.561A2.387 2.387 0 1 0 4.387 8H15.5a1 1 0 0 1 0 13 1 1 0 0 0 0-5H12a7 7 0 0 1-7-7V8" />
    <path d="M14 8a8.5 8.5 0 0 1 0 8" />
    <path d="M16 16c2 0 4.5-4 4-6" />
  </svg>
);

function MainComponent({ onLogout, user, logout }) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const location = useLocation();

  const socket = useSocket();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [alertTitle, setalertTitle] = useState("");

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (!socket) return;

    console.log("MainComponent socket initialized:", socket);

    // Listener for incoming calls
    socket.on("incomingCall", (data) => {
      console.log("Incoming call received:--", data);
      const currentAgent = JSON.parse(
        localStorage.getItem("userData")
      )?.EmployeePhone;

      if (
        data.agentNumber === currentAgent &&
        data.eventType === "incoming_call"
      ) {
        // Save incoming call data in localStorage
        const callStartTime = Date.now();
        localStorage.setItem("incomingCallData", JSON.stringify(data));
        localStorage.setItem("isIncoming", "true");
        localStorage.setItem("callId", data.callId);
        localStorage.setItem("phoneNumber", data.callerNumber);
        localStorage.setItem("isCalling", "true");
        localStorage.setItem("callStartTime", callStartTime);

        setOpenSnackbar(true);
        setSeverity("success");
        setMessage("You are getting a Call");

        if (location.pathname != "/dashboard") {
          localStorage.setItem("usethisOne", "true");
        }

        // Emit the "incomingCall" event instead of reloading
        emit("incomingCall", data);
        console.log("Emitting incoming call event:", data);
      }
    });

    // Listener for incoming call status updates
    socket.on("incomingCallStatus", (data) => {
      console.log("Incoming call status update:", data);

      const currentAgent = JSON.parse(
        localStorage.getItem("userData")
      )?.EmployeePhone;
      const storedCallId = localStorage.getItem("callId");

      if (data.agentNumber === currentAgent && storedCallId === data.callId) {
        if (data.eventType === "oncallconnect") {
          // Update localStorage with connection status
          localStorage.setItem("incomingCallConnected", "true");
          localStorage.setItem("isConnected", "true");

          // Update webhook data if needed
          localStorage.setItem("B_DIAL_STATUS", "Connected");

          // Emit an event for the caller component
          emit("incomingCallStatusUpdate", { isConnected: true });
        } else if (data.eventType === "call_ended") {
          // Reset call state in localStorage on call end
          resetCallStates();
          emit("incomingCallStatusUpdate", { isConnected: false });
        }
      }
    });

    // Cleanup listener
    return () => {
      socket.off("incomingCall");
      socket.off("incomingCallStatus");
    };
  });

  // Function to reset call states in localStorage
  const resetCallStates = () => {
    // Clear localStorage values related to call state
    localStorage.removeItem("incomingCallData");
    localStorage.removeItem("isIncoming");
    localStorage.removeItem("incomingCallConnected");
    localStorage.removeItem("isConnected");
    localStorage.removeItem("callId");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("isCalling");
    localStorage.removeItem("refreshPanel");
    localStorage.removeItem("B_DIAL_STATUS");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleprofileNavigate = () => {
    navigate("/profile");
    setAnchorEl(null);
  };

  const [openDialog, setOpenDialog] = useState(false);

  const attendance = localStorage.getItem("attendance");
  const outTime = attendance ? JSON.parse(attendance)?.outTime : null;

  const handleAttendanceOut = () => {
    setOpenDialog(true); // Open the confirmation dialog
    handleClose(); // Close the menu
  };

  const confirmAttendanceOut = () => {
    setOpenDialog(false); // Close the dialog
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        const payload = {
          bdmId: localStorage.getItem("username"),
          attendanceId:
            JSON.parse(localStorage.getItem("userData")).todayAttendance
              ?.attendanceId ||
            JSON.parse(localStorage.getItem("attendance")).attendanceId,
          latitude: latitude,
          longitude: longitude,
        };
        setLoading(true);

        try {
          const response = await axios.post(`${ATTENDANCE_OUT}`, payload);
          const { message } = response.data;

          setOpenSnackbar(true);
          setSeverity("success");
          setMessage(message);

          setTimeout(() => {
            handleLogout();
          }, 1000); // Delay for 1 seconds
        } catch (error) {
          console.error("Error submitting actions:", error);
          setOpenSnackbar(true);
          setSeverity("error");
          setMessage(error.response.data.message);
        } finally {
          setLoading(false);
        }
      },
      (error) => {
        console.error("Error fetching location:", error);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  };

  const cancelAttendanceOut = () => {
    setOpenDialog(false); // Close the dialog without proceeding
  };

  const handleLogout = () => {
    localStorage.clear();
    Cookies.remove("authToken", { path: "/" });
    navigate("/");
    navigate(0);
  };

  const [menuEl, setMenuEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [readNotification, setReadNotification] = useState([]);


  const [notificationFilter, setNotificationFilter] = React.useState("all");

// Derive notifications list based on filter
const visibleNotifications = React.useMemo(() => {
  if (notificationFilter === "unread") {
    return notifications.filter((n) => !n.isRead);
  }
  if (notificationFilter === "read") {
    return notifications.filter((n) => n.isRead);
  }
  return notifications; // all
}, [notifications, notificationFilter]);

  const handleNotificationOpen = (event) => {
    setTabIndex(0);
    setMenuEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setMenuEl(null);
  };

  const fetchUnreadNotification = async () => {
    try {
      if (localStorage.getItem("empRole") !== "6") return;

      const response = await axios.get(
        `${GET_NOTIFICATION}?employeeId=${localStorage.getItem(
          "username"
        )}&readStatus=unread`
      );

      setNotifications(response.data.notifications); // Set only unread notifications
      setUnreadCount(response.data?.counts?.unread);
    } catch (error) {
      console.error("Error fetching notifications", error);
    }
  };

  const fetchReadNotification = async () => {
    try {
      if (localStorage.getItem("empRole") !== "6") return;

      const response = await axios.get(
        `${GET_NOTIFICATION}?employeeId=${localStorage.getItem(
          "username"
        )}&readStatus=read`
      );

      setReadNotification(response.data.notifications); // Set only unread notifications
    } catch (error) {
      console.error("Error fetching notifications", error);
    }
  };

  useEffect(() => {
    fetchUnreadNotification(); // Initial call on mount
    fetchReadNotification();

    const interval = setInterval(() => {
      fetchUnreadNotification();
      fetchReadNotification();
    }, 300000); // Runs every 5 minutes (300,000 ms)

    return () => clearInterval(interval); // Cleanup function to avoid memory leaks
  }, []);

  const handleNotificationClick = async (notification) => {
    try {
      const payload = {
        notificationId: notification.id,
      };
      // Call the API to mark the notification as read
      const response = await axios.put(`${UPDATE_NOTIFICATION}`, payload);
      fetchUnreadNotification();
    } catch (error) {
      console.error("Error marking notification as read", error);
    }

    navigate("/bdmDetails/converted/view", {
      state: {
        MobNo: notification.leadDetail?.MobileNo,
        leadId: notification.leadDetailId,
      },
    });
    handleNotificationClose();
  };

  const handleClearAllNotifications = () => {};

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [bdmAssignedPage, setBdmAssignedPage] = useState(false);
  const [bdmToDoPage, setBdmToDoPage] = useState(false);
  const [leadpage, setLeadPage] = useState(false);
  const [supPage, setSupPage] = useState(false);
  const [auPage, setAuPage] = useState(false);
  const [biPage, setBipage] = useState(false);
  const [supbiPage, setSupBiPage] = useState(false);

  const [newOpen, setNewOpen] = useState(false);
  const toggleDrawer = () => {
    setNewOpen(true);
  };

  const storedRole = localStorage.getItem("empRole");

  useEffect(() => {
    if (storedRole == 2) {
      setBdmAssignedPage(true);
      setBdmToDoPage(true);
    }
    if (storedRole == 1) {
      setLeadPage(true);
    }
    if (storedRole == 5) {
      setSupPage(true);
    }
    if (storedRole == 201) {
      setSupBiPage(true);
    }
    if (storedRole == 200) {
      setBipage(true);
    }
    if (storedRole == 100) {
      setAuPage(true);
    }
  }, []);

  const path = window.location.pathname;

  console.log("cond", storedRole);

  const DrawerList = (
    <>
      <Box
        sx={{
          overflow: open ? "auto" : "hidden",
          backgroundColor: "#fff",
          height: "100%",
        }}
      >
        <List>
          {!(storedRole === "6" || storedRole === "7") && (
            <ListItem
              key={"dashboard"}
              button
              component={RouterLink}
              to="/dashboard"
              disablePadding
              className={
                path === "/dashboard"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={
                  path === "/dashboard" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Dashboard" arrow>
                  <SpeedIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Dashboard"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {(leadpage || storedRole == 3) && (
            <ListItem
              key={"lead"}
              disablePadding
              button
              component={RouterLink}
              to="/lead"
              className={
                path === "/lead"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={path === "/lead" ? `${leadFormStyles.active}` : ``}
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Category-Wise Lead" arrow>
                  <GroupIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Category-Wise Lead"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {leadpage && (
            <>
              <ListItem
                key={"enquiry_data"}
                disablePadding
                button
                component={RouterLink}
                to="/enquiry_data"
                className={
                  path === "/enquiry_data"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="QR Enquiry Leads" arrow>
                    <QrCodeIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"QR Enquiry Leads"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {bdmAssignedPage && (
            <ListItem
              key={"bdm_assigned"}
              disablePadding
              button
              component={RouterLink}
              to="/bdmAssigned"
              className={
                path === "/bdmAssigned"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Category-Wise Lead" arrow>
                  <GroupIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Category-Wise Lead"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {storedRole === "1" && (
            <ListItem
              key={"bdmDailyTask"}
              disablePadding
              button
              component={RouterLink}
              to="/bdmDailyTask"
              className={
                path === "/bdmDailyTask"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ""
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="BDM Daily Tasks" arrow>
                  <BookCheck />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"BDM Daily Tasks"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {/* {(bdmToDoPage || storedRole == 3) && (
            <ListItem
              key={"bdm_todo"}
              disablePadding
              button
              component={RouterLink}
              to="/bdmtodo" // Ensure the route matches your routing setup
              className={
                path === "/bdmtodo"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Today Tasks" arrow>
                  <CheckBoxOutlineBlankIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Today Tasks"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )} */}

          {supbiPage && (
            <>
              <ListItem
                key="bi_Dayop"
                disablePadding
                button
                component={RouterLink}
                to="/biMaster"
                className={
                  path === "/biMaster"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ""
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={path === "/biMaster" ? leadFormStyles.active : ""}
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="DayOp" arrow>
                    <PersonAddAltIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary="DayOp" sx={{ opacity: open ? 1 : 0 }} />
              </ListItem>

              <ListItem
                key={"bi_trader"}
                disablePadding
                button
                component={RouterLink}
                className={
                  path == "/biMasterBrooding"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                to="/biMasterBrooding"
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path == "/biMasterBrooding"
                      ? `${leadFormStyles.active}`
                      : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Brooding" arrow>
                    <ListIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Brooding"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {biPage && (
            <>
              <ListItem
                key={"bi_lead"}
                disablePadding
                button
                component={RouterLink}
                className={
                  path == "/biLead"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                to="/biLead"
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path == "/biLead" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Day Op" arrow>
                    <CloudIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Day Op"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>

              <ListItem
                key={"bi_trader"}
                disablePadding
                button
                component={RouterLink}
                className={
                  path == "/biTraderList"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                to="/biTraderList"
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path == "/biTraderList" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="BI" arrow>
                    <ListIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary={"BI"} sx={{ opacity: open ? 1 : 0 }} />
              </ListItem>
            </>
          )}

          {supPage && (
            <>
              <ListItem
                key={"lead_master"}
                disablePadding
                button
                component={RouterLink}
                to="/leadMaster"
                className={
                  path === "/leadMaster"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Leads Master" arrow>
                    <PersonAddAltIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Leads Master"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {supPage && (
            <>
              <ListItem
                key={"lead_action"}
                disablePadding
                button
                component={RouterLink}
                to="/leadAction"
                className={
                  path === "/leadAction"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Action by BDM" arrow>
                    <DashboardIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Action by BDM"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {supPage && (
            <>
              <ListItem
                key={"bdm_report"}
                disablePadding
                button
                component={RouterLink}
                to="/bdmReport"
                className={
                  path === "/bdmReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="BDM Report" arrow>
                    <ListChecks />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"BDM Report"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {supPage && (
            <>
              <ListItem
                key={"qr_report"}
                disablePadding
                button
                component={RouterLink}
                to="/qrReport"
                className={
                  path === "/qrReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="QR Enquiry Report" arrow>
                    <QrCodeIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"QR Enquiry Report"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {auPage && (
            <>
              <ListItem
                key={"audit_lead"}
                disablePadding
                button
                component={RouterLink}
                to="/auditLead"
                className={
                  path === "/auditLead"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path === "/auditLead" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Audit Lead" arrow>
                    <VerifiedUserIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Audit Lead"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>

              {/* <ListItem
                  key={'audit_trader'}
                  disablePadding
                  button
                  component={RouterLink}
                  to="/auditTraderList"
                  className={path === '/auditTraderList' ? `${leadFormStyles.active_back} ${leadFormStyles.active}` : ``}
                  sx={{
                    display: 'flex',
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    className={path === '/auditTraderList' ? `${leadFormStyles.active}` : ``}
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <Tooltip title="Trader" arrow>
                      <ListIcon />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={'Trader'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItem> */}
            </>
          )}

          {storedRole === "101" && (
            <ListItem
              key={"auditMaster"}
              disablePadding
              button
              component={RouterLink}
              to="/auditMaster"
              className={
                path === "/auditMaster"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={
                  path === "/auditMaster" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Audit Master" arrow>
                  <VerifiedUserIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Audit Master"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {(storedRole === "101" || storedRole === "100") && (
            <ListItem
              key={"calling_report"}
              disablePadding
              button
              component={RouterLink}
              to="/calling_report"
              className={
                path === "/calling_report"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Incoming Call Report" arrow>
                  <CallReceivedIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Incoming Call Report"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {(storedRole === "100" || storedRole === "101") && (
            <ListItem
              key={"outgoing_calling_report"}
              disablePadding
              button
              component={RouterLink}
              to="/outgoing_calling_report"
              className={
                path === "/outgoing_calling_report"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Outgoing Call Report" arrow>
                  <CallMadeIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Outgoing Call Report"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {(storedRole === "100" || storedRole === "101") && (
            <ListItem
              key={"work_hour_report"}
              disablePadding
              button
              component={RouterLink}
              to="/work_hour_report"
              className={
                path === "/work_hour_report"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Working Hour Report" arrow>
                  <HourglassTopIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Working Hour Report"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {(storedRole === "101" || storedRole === "100") && (
            <>
              <ListItem
                key={"remark_details_report"}
                disablePadding
                button
                component={RouterLink}
                to="/remark_details_report"
                className={
                  path === "/remark_details_report"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Remark Detail Report" arrow>
                    <ListAltIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Remark Detail Report"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>

              <ListItem
                key={"followup_details_report"}
                disablePadding
                button
                component={RouterLink}
                to="/followup_details_report"
                className={
                  path === "/followup_details_report"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Follow-up Detail Report" arrow>
                    <ViewListIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Follow-up Detail Report"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {/* {storedRole == '101' && <ListItem key={'auditTraderMaster'} 
              disablePadding 
              button component={RouterLink} 
              className={path == '/auditTraderList' ? `${leadFormStyles.active_back} ${leadFormStyles.active}` : ``}
              to="/auditTraderList"
              sx={{ display: 'flex',
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
               }}>
                <ListItemIcon
                className={ (path == '/auditTraderList' ? `${leadFormStyles.active}` : ``)}
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <Tooltip title="Trader" arrow>
                  <PersonIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary={'Trader'} sx={{ opacity: open ? 1 : 0 }} />
            </ListItem>} */}

          {storedRole === 6 && (
            <ListItem
              key={"ho_approval"}
              disablePadding
              button
              component={RouterLink}
              to="/estimateGeneration"
              className={
                path === "/estimateGeneration"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={
                  path === "/estimateGeneration"
                    ? `${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Estimate List" arrow>
                  <DomainVerificationIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"P-Card Estimation Requested"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {storedRole == 6 && (
            <ListItem
              key={"ho_approval"}
              disablePadding
              button
              component={RouterLink}
              to="/estimateGeneration"
              className={
                path === "/estimateGeneration"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={
                  path === "/estimateGeneration"
                    ? `${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Estimate List" arrow>
                  <DomainVerificationIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"P-Card Estimation Requested"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {storedRole === "5" && (
            <>
              <ListItem
                key={"attendance_report"}
                disablePadding
                button
                component={RouterLink}
                to="/attendanceReport"
                className={
                  path === "/attendanceReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Attendance Report" arrow>
                    <Calendar1 />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Attendance Report"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
              <ListItem
                key={"agent_calls"}
                disablePadding
                button
                component={RouterLink}
                to="/incoming-outgoing-call"
                className={
                  path === "/incoming-outgoing-call"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Agent Calls" arrow>
                    <PhoneCall />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Agent Calls"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {(storedRole === "2" || storedRole === "3") && (
            <>
              <ListItem
                key={"attendance_report"}
                disablePadding
                button
                component={RouterLink}
                to="/attendanceReport/details"
                className={
                  path === "/attendanceReport/details"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Travel Report" arrow>
                    <Calendar1 />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Travel Report"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {(storedRole === "2" || storedRole === "5" || storedRole === "3") && (
            <>
              <ListItem
                key={"leave_report"}
                disablePadding
                button
                component={RouterLink}
                to="/leaveReport"
                className={
                  path === "/leaveReport"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Leave Report" arrow>
                    <CircleUserRound />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Leave  Report"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {(storedRole === "7" || storedRole === "5" || storedRole === "3") && (
            <ListItem
              key={"hrReport"}
              button
              component={RouterLink}
              to="/hrReport"
              disablePadding
              className={
                path === "/hrReport"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={
                  path === "/hrReport" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="HR Report" arrow>
                  <FileDown />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"HR Report"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {(storedRole === "300" || storedRole === "301") && (
            <>
              <ListItem
                key={"shrimpLeads"}
                disablePadding
                button
                component={RouterLink}
                to="/shrimpLeads"
                className={
                  path === "/shrimpLeads"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path === "/shrimpLeads" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Leads it i" arrow>
                    <Shrimp size={24} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Leads"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}
          {(storedRole === "300" || storedRole === "301") && (
            <>
              <ListItem
                key={"incommingCalls"}
                disablePadding
                button
                component={RouterLink}
                to="/incommingCalls"
                className={
                  path === "/incommingCalls"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path === "/incommingCalls" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Incomming Calls" arrow>
                    <CallReceivedIcon size={24} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Incomming Calls"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}
          {(storedRole === "300" || storedRole === "301") && (
            <>
              <ListItem
                key={"outgoingCalls"}
                disablePadding
                button
                component={RouterLink}
                to="/outgoingCalls"
                className={
                  path === "/outgoingCalls"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path === "/outgoingCalls" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Outgoing Calls" arrow>
                    <CallMadeIcon size={24} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Outgoing Calls"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}
          {(storedRole === "300" || storedRole === "301") && (
            <>
              <ListItem
                key={"followupCalls"}
                disablePadding
                button
                component={RouterLink}
                to="/followupCalls"
                className={
                  path === "/followupCalls"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path === "/followupCalls" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Followup Calls" arrow>
                    <QueueIcon size={24} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Followup Calls"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {/* // agent incoming outgoing followup icon  */}

          {(storedRole === "1") && (
            <>
              <ListItem
                key={"incomingCallsAgent"}
                disablePadding
                button
                component={RouterLink}
                to="/incomingCallsAgent"
                className={
                  path === "/incomingCallsAgent"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path === "/incomingCallsAgent" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                > 
                 <Tooltip title="Incomming Calls" arrow>
                    <CallReceivedIcon size={24} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Incoming Calls"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}   
           {(storedRole === "1") && (
            <>
              <ListItem
                key={"outgoingCallsAgent"}
                disablePadding
                button
                component={RouterLink}
                to="/outgoingCallsAgent"
                className={
                  path === "/outgoingCallsAgent"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path === "/outgoingCallsAgent" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                > 
                  <Tooltip title="Outgoing Calls" arrow>
                    <CallMadeIcon size={24} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Outgoing Calls"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}  
         {(storedRole === "1") && (
            <>
              <ListItem
                key={"followupCallsAgent"}
                disablePadding
                button
                component={RouterLink}
                to="/followupCallsAgent"
                className={
                  path === "/followupCalls"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={
                    path === "/followupCallsAgent" ? `${leadFormStyles.active}` : ``
                  }
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                > 
                  <Tooltip title="Followup Calls" arrow>
                    <QueueIcon size={24} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Followup Calls"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}   

          {/* // agent incoming outgoing followup icon  */}

          {storedRole === "3" && (
            <ListItem
              key={"teamTravelReport"}
              disablePadding
              button
              component={RouterLink}
              to="/teamTravelReport"
              className={
                path === "/teamTravelReport"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={
                  path === "/teamTravelReport" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Team Travel Report" arrow>
                  <Users />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"Team Travel Report"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {storedRole === "3" && (
            <ListItem
              key={"bdmTaskReport"}
              disablePadding
              button
              component={RouterLink}
              to="/bdmTaskReport"
              className={
                path === "/bdmTaskReport"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={
                  path === "/bdmTaskReport" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="BDM Task Report" arrow>
                  <ChartBar size={24} />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"BDM Task Report"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItem>
          )}

          {supPage && (
            <>
              <ListItem
                key={"settings"}
                disablePadding
                button
                component={RouterLink}
                to="/settings"
                className={
                  path === "/settings"
                    ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                    : ``
                }
                sx={{
                  display: "flex",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Settings" arrow>
                    <SettingsIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={"Settings"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </>
          )}

          {/* {storedRole === "6" && (
            <ListItem
              key={"mdm-list"}
              disablePadding
              button
              component={RouterLink}
              to="/mdm-list"
              className={
                path === "/mdm-list"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={
                  path === "/mdm-list" ? `${leadFormStyles.active}` : ``
                }
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="MDM" arrow>
                  <ChartBar size={24} />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={"MDM"} sx={{ opacity: open ? 1 : 0 }} />
            </ListItem>
          )} */}
        </List>

        {/* <List>
          {storedRole === "1001" && (
            <ListItem
              key={"Report"}
              button
              component={RouterLink}
              to="/Report"
              disablePadding
              className={
                path === "/Report"
                  ? `${leadFormStyles.active_back} ${leadFormStyles.active}`
                  : ``
              }
              sx={{
                display: "flex",
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                className={path === "/Report" ? `${leadFormStyles.active}` : ``}
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Report" arrow>
                  <BadgeIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={"Report"} sx={{ opacity: open ? 1 : 0 }} />
            </ListItem>
          )}
        </List> */}
        {open && (
          <Box
            sx={{
              position: "absolute",
              bottom: 16,
              width: "100%",
              paddingLeft: 2,
            }}
          >
            <Typography variant="body2" color="text.secondary" align="center">
              Version 1.12.0
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );

  const roles =
    JSON.parse(localStorage.getItem("userData")) == null
      ? ""
      : ROLES.filter(
          (item) =>
            item.id == JSON.parse(localStorage.getItem("userData")).EmployeeRole
        );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              // marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>

          {open == false && (
            <img src={ib_logo} loading="lazy" alt="onCall" className={`w-10`} />
          )}

          <div style={{ marginLeft: "auto" }}>
            {localStorage.getItem("empRole") === "6" && (
              <>
                {/* Bell Icon with Badge */}
                <IconButton color="inherit" onClick={handleNotificationOpen}>
                  <Badge badgeContent={unreadCount} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>

                {/* Notification Menu */}
                <Menu
                  anchorEl={menuEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  open={Boolean(menuEl)}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  onClose={handleNotificationClose}
                  PaperProps={{
                    elevation: 4,
                    sx: {
                      filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.3))",
                      mt: 1.5,
                      overflow: "visible",
                      width: "350px",
                      maxHeight: "450px",
                      borderRadius: "12px",
                      animation: "fadeIn 0.2s ease-in-out",
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 12,
                        height: 12,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 1,
                      },
                      "@keyframes fadeIn": {
                        from: { opacity: 0 },
                        to: { opacity: 1 },
                      },
                    },
                  }}
                >
                  {/* Tabs for Unread and Read Notifications */}
                  <Tabs
                    value={tabIndex}
                    onChange={(_, newIndex) => setTabIndex(newIndex)}
                    variant="fullWidth"
                    textColor="primary"
                    indicatorColor="primary"
                  >
                    <Tab label={`Unread (${notifications.length})`} />
                    <Tab label={`Read (${readNotification.length})`} />
                  </Tabs>

                  {/* Scrollable Notification Content */}
                  <Box sx={{ maxHeight: "350px", overflowY: "auto", p: 1 }}>
                    {(tabIndex === 0 ? notifications : readNotification)
                      .length > 0 ? (
                      (tabIndex === 0 ? notifications : readNotification).map(
                        (notification) => (
                          <Box
                            key={notification.id}
                            sx={{
                              bgcolor: !notification.isRead
                                ? "rgba(0, 0, 255, 0.1)"
                                : "inherit",
                              borderRadius: "8px",
                              transition: "background 0.3s",
                              "&:hover": {
                                bgcolor: "rgba(0, 0, 255, 0.2)",
                              },
                              p: 1,
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <MenuItem
                              onClick={() =>
                                handleNotificationClick(notification)
                              }
                              sx={{ width: "100%" }}
                            >
                              {/* Notification Icon */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  mr: 1,
                                }}
                              >
                                {notification.type === "document" ? (
                                  <InsertDriveFileIcon color="primary" />
                                ) : (
                                  <NotificationsActiveIcon color="secondary" />
                                )}
                              </Box>

                              <Box sx={{ flex: 1 }}>
                                <Typography
                                  variant="body1"
                                  fontWeight={
                                    notification.isRead ? "normal" : "bold"
                                  }
                                >
                                  {notification.title || "Notification"}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "pre-wrap",
                                    color: "text.secondary",
                                  }}
                                >
                                  {notification.text}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                >
                                  {moment(notification.createdAt).fromNow()}
                                </Typography>
                              </Box>
                            </MenuItem>
                          </Box>
                        )
                      )
                    ) : (
                      <MenuItem disabled>
                        <Typography
                          variant="body1"
                          sx={{ textAlign: "center", width: "100%" }}
                        >
                          No {tabIndex === 0 ? "Unread" : "Read"} Notifications
                        </Typography>
                      </MenuItem>
                    )}
                  </Box>
                </Menu>
              </>
            )}

               {localStorage.getItem("empRole") === "2" && (
                  <NotificationComponent/>
            )}
               {localStorage.getItem("empRole") === "3" && (
                  <NotificationComponent/>
            )}

            <IconButton onClick={handleClick} color="inherit">
              <AccountCircleTwoTone sx={{ fontSize: "2rem !important" }} />
              <div className={`flex-row ml-1 mr-1`}>
                <p style={{ fontSize: "0.8rem", textTransform: "capitalize" }}>
                  {JSON.parse(localStorage.getItem("userData")) == null
                    ? ""
                    : JSON.parse(localStorage.getItem("userData")).EmployeeName}
                </p>
                <p style={{ fontSize: "0.6rem", textAlign: "left" }}>
                  {roles == "" ? "" : roles[0].role}
                </p>
              </div>
              <ExpandMoreIcon sx={{ fontSize: "1.2rem !important" }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              className={`w-100`}
            >
              <MenuItem onClick={handleprofileNavigate}>
                <AccountCircle className={`mr-2`} />
                Profile
              </MenuItem>
              <Divider />
              {(localStorage.getItem("empRole") === "2" ||
                localStorage.getItem("empRole") === "3") && (
                <MenuItem
                  onClick={handleAttendanceOut}
                  disabled={!attendance || outTime !== null}
                >
                  <TimerOffIcon className="mr-2" />
                  Attendance Out
                </MenuItem>
              )}
              <Divider />
              <MenuItem onClick={handleLogout}>
                <LogoutIcon className={`mr-2`} />
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer variant={"permanent"} open={open}>
        <DrawerHeader sx={{ placeContent: "space-between" }}>
          {open == true && (
            <img src={ib_logo} loading="lazy" alt="onCall" className={`w-10`} />
          )}
          <IconButton onClick={handleDrawerClose} sx={{ color: "#fff" }}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        {DrawerList}
      </Drawer>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

      {/* Confirmation Dialog for Attendance Out */}
      <Dialog open={openDialog} onClose={cancelAttendanceOut}>
        <DialogTitle>Confirm Attendance Out</DialogTitle>
        <DialogContent>
          Are you sure you want to mark yourself as "Attendance Out"? This
          action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelAttendanceOut} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmAttendanceOut} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainComponent);
